import { render, staticRenderFns } from "./declarations.vue?vue&type=template&id=7a921f19&scoped=true&"
import script from "./declarations.vue?vue&type=script&lang=js&"
export * from "./declarations.vue?vue&type=script&lang=js&"
import style0 from "./declarations.vue?vue&type=style&index=0&id=7a921f19&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a921f19",
  null
  
)

export default component.exports